// ----------------------------------------------------------------------
// <copyright file="Izenda.Relationship.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';

import IconMenu from 'share/components/controls/Izenda.IconMenu';
import Button from 'share/components/controls/Izenda.Button';
import ActionBar from 'share/components/controls/Izenda.ActionBar';
import RelationshipList from './Izenda.RelationshipList';
import DataGridSearch from 'share/components/controls/DataGrid/Izenda.DataGridSearch';
import Alert from 'share/components/controls/Izenda.Alert';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import actions from './Izenda.RelationshipActions';
import InvalidRelationship from './Izenda.InvalidRelationship';
import UiState from 'logic/Izenda.UiState';

@connect(actions)
class Relationship extends Component {
  componentDidMount() {
    const props = this.props;
    const { store, loader, validation, isPopup } = props;

    props.updateLoading(true);
    loader.startLoading();
    store.initData(isPopup).then(function() {
      props.updateLoading(false);
      loader.endLoading();
      validation.validate();
    });
  }

  componentWillUnmount() {
    this.props.store.destroy(this.props.isPopup);
  }

  resetAlertMessage = () => {
    const { store } = this.props;
    store.alertMessage = CommonMessages.EMPTY_MESSAGE;
  };

  /**
   * render main function
   */
  render() {
    const {
      store,
      store: { alertMessage },
      localization
    } = this.props;

    return !store.showInvalidScreen ? (
      <section className='izenda-Wrapper izenda-QuerySource'>
        <div className='izenda-Wrapper-header'>
          <IconMenu />
          <div className='izenda-Alert-container'>
            <Alert type={alertMessage.type} onAutoHide={this.resetAlertMessage}>
              {alertMessage.message}
            </Alert>
          </div>
          <div className='u_inlineBlock'>
            <DataGridSearch
              onSearch={this.props.onSearch}
              value={store.pageInfo.searchProperty}
              options={store.getCriteriaList()}
            />
          </div>
          {/* button groups*/}
          <ActionBar onSave={this.props.onSave} onCancel={this.props.onCancel}>
            <Button onClick={this.props.onAdd} label={localization.getText('REPORTDESIGNER_LABEL_ADD_RELATIONSHIP')} />
            {UiState.currentUser.systemAdmin && (
              <Button className='btn-report-default' onClick={this.props.onExport} label={localization.getText('DATA_MODEL_LABEL_EXPORT')} />
            )}
          </ActionBar>
        </div>
        <div className='izenda-Wrapper-content'>
          {/* list of relationship*/}
          <RelationshipList
            store={store}
            width={this.props.width}
            isPopup={this.props.isPopup}
            isLoading={this.props.isLoading}
          />
        </div>
      </section>
    ) : (
      <InvalidRelationship {...this.props} />
    );
  }
}

Relationship.defaultProps = {
  isPopup: false
};

Relationship.propTypes = {
  store: PropTypes.object.isRequired,
  querySourceId: PropTypes.string,
  isPopup: PropTypes.bool
};

export default Relationship;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.Relationship.jsx